var map = {
	"./barra.png": "2d2f",
	"./btnherramientas.png": "80bd",
	"./cancel.png": "17aa",
	"./check-green.png": "8c66",
	"./custom/blank.png": "b769",
	"./custom/checkered.png": "a072",
	"./custom/rowed.png": "53ee",
	"./double.png": "a690",
	"./draw/b1.png": "95b7",
	"./draw/check.svg": "c698",
	"./draw/cross.svg": "f250",
	"./draw/eraser-black.png": "9085",
	"./draw/link.svg": "0dee",
	"./draw/nicEditorIcons.gif": "2f61",
	"./draw/note.svg": "3e2e",
	"./draw/resaltador-black.png": "8a42",
	"./dropdown-arrow.png": "74b0",
	"./dropdown-arrow.svg": "2393",
	"./equis-red.png": "fe27",
	"./equis.png": "93f8",
	"./flecha.svg": "e689",
	"./flechaFooter-Active.svg": "33b6",
	"./flechafooter.svg": "1133",
	"./help.png": "d852",
	"./herramientas/cronometro.png": "7b58",
	"./herramientas/eraser-black.png": "3fe8",
	"./herramientas/eraser.png": "1a30",
	"./herramientas/fondo.png": "ba94",
	"./herramientas/link+.png": "0580",
	"./herramientas/link-.png": "55dd",
	"./herramientas/link.png": "8d50",
	"./herramientas/move.png": "9aac",
	"./herramientas/resaltador-black.png": "7068",
	"./herramientas/resaltador.png": "4913",
	"./herramientas/tampon.png": "0b62",
	"./hide.png": "5116",
	"./iconActi/audio.png": "c21b",
	"./iconActi/edit.png": "e05d",
	"./iconActi/icono-btnLINK.png": "a154",
	"./iconActi/teacher.png": "6b09",
	"./iconActi/video.png": "949f",
	"./iconActi/wbteacher.png": "4a1d",
	"./logo.png": "4ffd",
	"./lupa.png": "599c",
	"./mybook/blank.png": "f88c",
	"./mybook/checkered.png": "941c",
	"./mybook/rowed.png": "8cfb",
	"./next.svg": "dd0a",
	"./no-image.jpg": "64a0",
	"./paginas/LA/1.jpg": "3a36",
	"./paginas/LA/10.jpg": "5d8b",
	"./paginas/LA/100.jpg": "de5d",
	"./paginas/LA/101.jpg": "6523",
	"./paginas/LA/102.jpg": "5815",
	"./paginas/LA/103.jpg": "82e4",
	"./paginas/LA/104.jpg": "68b8",
	"./paginas/LA/105.jpg": "2c80",
	"./paginas/LA/106.jpg": "89ae",
	"./paginas/LA/107.jpg": "df39",
	"./paginas/LA/108.jpg": "5581",
	"./paginas/LA/109.jpg": "99d8",
	"./paginas/LA/11.jpg": "f16e",
	"./paginas/LA/110.jpg": "c86e",
	"./paginas/LA/111.jpg": "faa8",
	"./paginas/LA/112.jpg": "0bf2",
	"./paginas/LA/113.jpg": "6b10",
	"./paginas/LA/114.jpg": "fd06",
	"./paginas/LA/115.jpg": "e986",
	"./paginas/LA/116.jpg": "c00e",
	"./paginas/LA/117.jpg": "11f8",
	"./paginas/LA/118.jpg": "add7",
	"./paginas/LA/119.jpg": "a795",
	"./paginas/LA/12.jpg": "666c",
	"./paginas/LA/120.jpg": "da50",
	"./paginas/LA/13.jpg": "3551",
	"./paginas/LA/14.jpg": "46db",
	"./paginas/LA/15.jpg": "0ef9",
	"./paginas/LA/16.jpg": "3fec",
	"./paginas/LA/17.jpg": "7847",
	"./paginas/LA/18.jpg": "ae3b",
	"./paginas/LA/19.jpg": "7fda",
	"./paginas/LA/2.jpg": "b2e1",
	"./paginas/LA/20.jpg": "2c5d",
	"./paginas/LA/21.jpg": "139a",
	"./paginas/LA/22.jpg": "9f25",
	"./paginas/LA/23.jpg": "32d0",
	"./paginas/LA/24.jpg": "f21c",
	"./paginas/LA/25.jpg": "39d1",
	"./paginas/LA/26.jpg": "a3eb",
	"./paginas/LA/27.jpg": "a78e",
	"./paginas/LA/28.jpg": "e303",
	"./paginas/LA/29.jpg": "6903",
	"./paginas/LA/3.jpg": "7fd9",
	"./paginas/LA/30.jpg": "af6f",
	"./paginas/LA/31.jpg": "960d",
	"./paginas/LA/32.jpg": "b83d",
	"./paginas/LA/33.jpg": "4129",
	"./paginas/LA/34.jpg": "fd8e",
	"./paginas/LA/35.jpg": "35ea",
	"./paginas/LA/36.jpg": "f6fe",
	"./paginas/LA/37.jpg": "58ec",
	"./paginas/LA/38.jpg": "9195",
	"./paginas/LA/39.jpg": "9b00",
	"./paginas/LA/4.jpg": "d496",
	"./paginas/LA/40.jpg": "5560",
	"./paginas/LA/41.jpg": "bd06",
	"./paginas/LA/42.jpg": "e8a7",
	"./paginas/LA/43.jpg": "6ca1",
	"./paginas/LA/44.jpg": "cf1a",
	"./paginas/LA/45.jpg": "1e97",
	"./paginas/LA/46.jpg": "9052",
	"./paginas/LA/47.jpg": "2d73",
	"./paginas/LA/48.jpg": "8ee4",
	"./paginas/LA/49.jpg": "3bc4",
	"./paginas/LA/5.jpg": "616f",
	"./paginas/LA/50.jpg": "604f",
	"./paginas/LA/51.jpg": "ad6d0",
	"./paginas/LA/52.jpg": "54ae",
	"./paginas/LA/53.jpg": "91e1",
	"./paginas/LA/54.jpg": "da16",
	"./paginas/LA/55.jpg": "9727",
	"./paginas/LA/56.jpg": "5085",
	"./paginas/LA/57.jpg": "3430",
	"./paginas/LA/58.jpg": "44f1",
	"./paginas/LA/59.jpg": "11b6",
	"./paginas/LA/6.jpg": "e679",
	"./paginas/LA/60.jpg": "b395",
	"./paginas/LA/61.jpg": "572d",
	"./paginas/LA/62.jpg": "4f30",
	"./paginas/LA/63.jpg": "2dad",
	"./paginas/LA/64.jpg": "5721",
	"./paginas/LA/65.jpg": "e3d3",
	"./paginas/LA/66.jpg": "ea1c",
	"./paginas/LA/67.jpg": "9cd3",
	"./paginas/LA/68.jpg": "a593",
	"./paginas/LA/69.jpg": "2329",
	"./paginas/LA/7.jpg": "9d266",
	"./paginas/LA/70.jpg": "6a57",
	"./paginas/LA/71.jpg": "17da",
	"./paginas/LA/72.jpg": "81e7",
	"./paginas/LA/73.jpg": "5bf0",
	"./paginas/LA/74.jpg": "0ad9",
	"./paginas/LA/75.jpg": "4b37",
	"./paginas/LA/76.jpg": "8008",
	"./paginas/LA/77.jpg": "1d8b",
	"./paginas/LA/78.jpg": "3f24",
	"./paginas/LA/79.jpg": "3da8",
	"./paginas/LA/8.jpg": "b531",
	"./paginas/LA/80.jpg": "2ee3",
	"./paginas/LA/81.jpg": "117a",
	"./paginas/LA/82.jpg": "e6dc",
	"./paginas/LA/83.jpg": "196c",
	"./paginas/LA/84.jpg": "4ebf",
	"./paginas/LA/85.jpg": "1c47",
	"./paginas/LA/86.jpg": "b63d",
	"./paginas/LA/87.jpg": "a838",
	"./paginas/LA/88.jpg": "2e55",
	"./paginas/LA/89.jpg": "5533",
	"./paginas/LA/9.jpg": "dd30",
	"./paginas/LA/90.jpg": "8197",
	"./paginas/LA/91.jpg": "de0c",
	"./paginas/LA/92.jpg": "041f",
	"./paginas/LA/93.jpg": "83b5",
	"./paginas/LA/94.jpg": "4f80",
	"./paginas/LA/95.jpg": "930d",
	"./paginas/LA/96.jpg": "be5d",
	"./paginas/LA/97.jpg": "7424",
	"./paginas/LA/98.jpg": "16f7",
	"./paginas/LA/99.jpg": "3509",
	"./pdf.png": "77ef",
	"./recursos.png": "7b31",
	"./show.png": "41d5",
	"./single.png": "d1c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";